import { theme } from '@chakra-ui/core';

export default {
  ...theme,
  fonts: {
    ...theme.fonts,
    heading: 'Comfortaa, sans-serif',
    body: 'Open Sans, sans-serif',
  },
};
